var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronColorless = function SvgChevronColorless(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.333 9.063-.943-.944-6.23 6.231-6.23-6.23-.943.943 7.174 7.172z",
    fill: "#fff"
  })));
};
export { SvgChevronColorless as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjUgMjUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBkPSJtMTkuMzMzIDkuMDYzLS45NDMtLjk0NC02LjIzIDYuMjMxLTYuMjMtNi4yMy0uOTQzLjk0MyA3LjE3NCA3LjE3MnoiIGZpbGw9IiNmZmZmZmYiLz4KPC9zdmc+Cg==";